module.exports = __webpack_public_path__ + "img/27_74.4416aecc.png";